import dayjs from "dayjs";
import { DATE_FORMAT_WITH_TIME, DATE_FORMAT_WITH_TIME_AND_SECONDS } from "localConstants.ts";
import React from "react";

interface DateTimeCellProps {
    value?: string | Date;
    showSeconds?: boolean;
}

export const DateTimeCell: React.FC<DateTimeCellProps> = ({ value, showSeconds = false }) => {
    if (!value) return <>–</>;
    return <>{dayjs(value).format(showSeconds ? DATE_FORMAT_WITH_TIME_AND_SECONDS : DATE_FORMAT_WITH_TIME)}</>;
};
